import React, { ReactNode } from 'react';

export type FormEditParams = {
    formName: string;
    cssName?: string;
    fieldsetId?: string;
    children: ReactNode;
};

const FormEdit = ({ formName, cssName, fieldsetId, children }: FormEditParams): JSX.Element => {
    return (
        <form
            className={`form-edit query-form ${cssName ?? ''}`}
            name={formName}
        >
            <fieldset id={fieldsetId}>{children}</fieldset>
        </form>
    );
};

export default FormEdit;
